import { render, staticRenderFns } from "./PCareerTemplate.vue?vue&type=template&id=1f4819a1&scoped=true&"
import script from "./PCareerTemplate.vue?vue&type=script&lang=ts&"
export * from "./PCareerTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./PCareerTemplate.vue?vue&type=style&index=0&id=1f4819a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4819a1",
  null
  
)

export default component.exports